import { render, staticRenderFns } from "./BENavigation.vue?vue&type=template&id=e4406510&scoped=true&"
import script from "./BENavigation.vue?vue&type=script&lang=js&"
export * from "./BENavigation.vue?vue&type=script&lang=js&"
import style0 from "./BENavigation.vue?vue&type=style&index=0&id=e4406510&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4406510",
  null
  
)

export default component.exports